import React, { useEffect, useRef, useState } from 'react';
import { Action, IChatState } from '../../../../interfaces/chat.interface';
import ToolTip from '../../tool-tip/ToolTip';
import CloseChat from '../close/CloseChat';
import ChatOptions from '../options/ChatOptions';
import './ChatHeader.scss';

// @ts-ignore
import settingIcon from '../../../../assets/icons/CDA/settings.svg';
// @ts-ignore
import chatIcon from '../../../../assets/icons/CDA/chat.svg';

interface IProps {
    chatState: IChatState;
    setChatState: React.Dispatch<Action>;
}

const ChatHeader = ({ chatState, setChatState }: IProps) => {
    const [showOptions, setShowOptions] = useState(false);
    const [showCloseChat, setShowCloseChat] = useState(false);

    const refOptions = useRef<HTMLDivElement | null>(null);
    const refButtonOptions = useRef<HTMLButtonElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (
            refOptions.current &&
            !refOptions.current.contains(event.target as Node) &&
            refButtonOptions.current &&
            !refButtonOptions.current.contains(event.target as Node)
        ) {
            setShowOptions(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className="m-chatHeader">
                <div className="m-chatHeader__title">
                    <img src={chatIcon} alt="chat icon" />
                    Chatea con nuestra IA
                </div>

                <div className="m-chatHeader__buttons">
                    <ToolTip message="Opciones" hideMobile>
                        <button
                            onClick={() => setShowOptions(!showOptions)}
                            ref={refButtonOptions}
                            aria-label="Mostrar opciones"
                        >
                            <img src={settingIcon} alt="chat icon" />
                        </button>
                    </ToolTip>
                    {showOptions && (
                        <ChatOptions
                            chatState={chatState}
                            setChatState={setChatState}
                            refOptions={refOptions}
                        />
                    )}
                    <ToolTip message="Minimizar" hideMobile>
                        <button
                            onClick={() =>
                                setChatState({ type: 'TOGGLE_CHAT' })
                            }
                            aria-label="Minimizar chat"
                        >
                            <i className="icon icon-map1" />
                        </button>
                    </ToolTip>
                    <ToolTip message="Cerrar" hideMobile>
                        <button
                            onClick={() => setShowCloseChat(true)}
                            aria-label="Cerrar chat"
                        >
                            <i className="icon icon-circle1" />
                        </button>
                    </ToolTip>
                </div>
            </div>

            {showCloseChat && (
                <CloseChat
                    setChatState={setChatState}
                    setShowCloseChat={() => setShowCloseChat(false)}
                />
            )}
        </>
    );
};

export default ChatHeader;
